import React, { useContext } from "react";
import { CartContext } from "../POS";
import { no_img } from "../../../../assets";
import { IconButton } from "@mui/material";
import { CloseRounded } from "@mui/icons-material";
import OutOfStockInvError from "./OutOfStockInvError";
import { useFormatPrice } from "hooks";

const CartProdHeader = ({ item }) => {
  const { setCartData } = useContext(CartContext);
  const formatPrice = useFormatPrice();

  const rmvCartItem = (e, item) => {
    e.stopPropagation();
    setCartData((j) => ({
      ...j,
      sellItems: j.sellItems.filter((x) => x.key !== item.key),
    }));
  };

  return (
    <>
      <div className="mb-[5px] mt-[5px] w-[100%]">
        <div className="flex gap-15 justify-between items-center">
          <div>
            <div className="flex items-center gap-[10px]">
              {/* Inventory Warning */}
              {item.outOfStock && <OutOfStockInvError item={item} />}
              <div>
                <img
                  src={
                    item.image && URL.createObjectURL(item.image)
                      ? item.prod.imgs[0].imgUrl
                      : no_img
                  }
                  className="rounded-[4px] !h-[50px] !w-[50px] object-cover"
                  alt="product_img"
                />
              </div>

              <div className="grid">
                {/* Product Name */}
                <span className="text-[14px] font-medium text-gray-500">
                  {item.prod.name}
                </span>
                {/* Product Description */}
                <span className="text-[12px] font-semibold text-gray-500">
                  Qty: {item.qty}
                  {item.varProd &&
                    ` | ${item.varProd.attrVal1} ${
                      item.varProd.attrVal2 && " / " + item.varProd.attrVal2
                    } ${
                      item.varProd.attrVal3 && " / " + item.varProd.attrVal3
                    }`}
                </span>
              </div>
            </div>
          </div>
          <div className="flex items-center gap-[15px]">
            <div className="grid w-max">
              {/* Discount Amount */}
              <span className="font-medium text-gray-500">
                {formatPrice(item.totalPrice)}
              </span>
              {/* Without Discount */}
              {item.disAmt > 0 && (
                <span className="font-medium text-[13px] text-gray-500 line-through">
                  {formatPrice(item.totalPrice + parseFloat(item.disAmt))}
                </span>
              )}
            </div>

            <IconButton
              onClick={(e) => rmvCartItem(e, item)}
              size="small"
              color="error"
              className="p-0"
            >
              <CloseRounded className="fs-18 m-5" />
            </IconButton>
          </div>
        </div>
      </div>
    </>
  );
};

export default CartProdHeader;
